import { useMutation, useSuspenseQuery } from '@tanstack/react-query';
import PrinterForm from '../../components/PrinterForm';
import { fetchPrinter, updatePrinter } from './api';
import { PrinterItem } from '../../types';
import ErrorBoundary from '~/App/components/ErrorBoundary';
import { Suspense } from 'react';
import Loading from '~/App/components/Loading';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import message from '~/utils/message';

const EditPrinterForm = ({ id }: { id: string }) => {
  const navigate = useNavigate();
  const { data, isLoading } = useSuspenseQuery({
    queryKey: ['printer', id],
    queryFn: () => fetchPrinter(id),
    refetchOnMount: true,
    staleTime: 0,
    gcTime: 0,
  });
  const { isPending, mutate } = useMutation({
    mutationFn: updatePrinter,
    retry: false,
    onSuccess: () => {
      message.success('Successfully updated printer');
      navigate('..');
    },
    onError: () => {
      message.error('Fail to update printer');
    },
  });

  const onSubmit = (values: PrinterItem) => {
    mutate({ id, values });
  };

  if (isLoading) return null;

  return (
    <PrinterForm initialValues={data} loading={isPending} onSubmit={onSubmit} />
  );
};

const EditPrinter = () => {
  const { id } = useParams();

  if (!id) return <Navigate to=".." />;

  return (
    <div className="p-6">
      <div className="mb-6 flex justify-between items-center">
        <h1 className="text-2xl">Edit Printer</h1>
      </div>
      <div className="max-w-[800px]">
        <ErrorBoundary>
          <Suspense fallback={<Loading />}>
            <EditPrinterForm id={id} />
          </Suspense>
        </ErrorBoundary>
      </div>
    </div>
  );
};

export default EditPrinter;
